module.exports = __webpack_public_path__ + "img/Adobe_Photoshop.0b376d3c.png";